'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface FilterBarProps {
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  projectCounts: {
    all: number;
    웹: number;
    앱: number;
  };
}

const FilterBar = ({
  selectedCategory,
  onCategoryChange,
  searchQuery,
  onSearchChange,
  projectCounts
}: FilterBarProps) => {
  const categories = [
    { id: 'all', name: '전체 프로젝트', count: projectCounts.all },
    { id: '웹', name: '웹 (반응형)', count: projectCounts.웹 },
    { id: '앱', name: '모바일 앱', count: projectCounts.앱 }
  ];

  return (
    <div data-component-id="src/app/portfolio/components/FilterBar.tsx:32:4" data-component-path="src/app/portfolio/components/FilterBar.tsx" data-component-line="32" data-component-file="FilterBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-surface%20border-b%20border-border%22%7D" className="bg-surface border-b border-border">
      <div data-component-id="src/app/portfolio/components/FilterBar.tsx:33:6" data-component-path="src/app/portfolio/components/FilterBar.tsx" data-component-line="33" data-component-file="FilterBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-6%20lg%3Apx-8%20py-6%22%7D" className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
        {/* Search Bar */}
        <div data-component-id="src/app/portfolio/components/FilterBar.tsx:35:8" data-component-path="src/app/portfolio/components/FilterBar.tsx" data-component-line="35" data-component-file="FilterBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-6%22%7D" className="mb-6">
          <div data-component-id="src/app/portfolio/components/FilterBar.tsx:36:10" data-component-path="src/app/portfolio/components/FilterBar.tsx" data-component-line="36" data-component-file="FilterBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20max-w-md%22%7D" className="relative max-w-md">
            <div data-component-id="src/app/portfolio/components/FilterBar.tsx:37:12" data-component-path="src/app/portfolio/components/FilterBar.tsx" data-component-line="37" data-component-file="FilterBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-y-0%20left-0%20pl-3%20flex%20items-center%20pointer-events-none%22%7D" className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Icon data-component-id="src/app/portfolio/components/FilterBar.tsx:38:14" data-component-path="src/app/portfolio/components/FilterBar.tsx" data-component-line="38" data-component-file="FilterBar.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22MagnifyingGlassIcon%22%2C%22className%22%3A%22text-text-secondary%22%7D" name="MagnifyingGlassIcon" size={20} className="text-text-secondary" />
            </div>
            <input data-component-id="src/app/portfolio/components/FilterBar.tsx:40:12" data-component-path="src/app/portfolio/components/FilterBar.tsx" data-component-line="40" data-component-file="FilterBar.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22text%22%2C%22value%22%3A%22%5Bvar%3AsearchQuery%5D%22%2C%22className%22%3A%22input%20pl-10%20w-full%22%7D"
              type="text"
              placeholder="프로젝트 검색..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              className="input pl-10 w-full"
            />
          </div>
        </div>

        {/* Category Filters */}
        <div data-component-id="src/app/portfolio/components/FilterBar.tsx:51:8" data-component-path="src/app/portfolio/components/FilterBar.tsx" data-component-line="51" data-component-file="FilterBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20gap-3%22%7D" className="flex flex-wrap gap-3">
          {categories.map((category) => (
            <button data-component-id="src/app/portfolio/components/FilterBar.tsx:53:12" data-component-path="src/app/portfolio/components/FilterBar.tsx" data-component-line="53" data-component-file="FilterBar.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
              key={category.id}
              onClick={() => onCategoryChange(category.id)}
              className={`px-4 py-2 text-sm font-medium border transition-all duration-200 ${
                selectedCategory === category.id
                  ? 'bg-primary text-primary-foreground border-primary'
                  : 'bg-background text-text-secondary border-border hover:border-accent hover:text-accent'
              }`}
            >
              {category.name}
              <span data-component-id="src/app/portfolio/components/FilterBar.tsx:63:14" data-component-path="src/app/portfolio/components/FilterBar.tsx" data-component-line="63" data-component-file="FilterBar.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22ml-2%20text-xs%20opacity-75%22%2C%22textContent%22%3A%22(%20)%22%7D" className="ml-2 text-xs opacity-75">
                ({category.count})
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FilterBar;